<template>
  <div
    class="plus-icon-button-wrapper"
    :class="{ cross: isCross, disabled: disabled }"
    @click="onClick"
  >
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="29" cy="29" r="29" :fill="buttonColor" />
      <path
        d="M20.9287 29H37.9998M29.4642 37.5355V20.4645"
        :stroke="iconColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PlusIconButton',
  props: {
    buttonColor: {
      type: String,
      default: '#333343',
    },
    iconColor: {
      type: String,
      default: '#ffffff',
    },

    isCross: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit('onClick', event);
    },
  },
};
</script>
<style scoped>
.plus-icon-button-wrapper {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
}

.plus-icon-button-wrapper:hover:not(.disabled) {
  transform: scale(1.1);
}

.plus-icon-button-wrapper.cross {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.plus-icon-button-wrapper.disabled {
  opacity: 0.5;
}
</style>
